import { FC } from 'react';
import { Card, withStyles, Flag, formatAmount } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Balance } from '@/hooks/useApi/useAccountBalances';
import { AccountType } from '../AccountSummaryPage';
import AccountTypeBadge from '../AccountUI/AccountTypeBadge';
// import StartInterestTooltip from '../AccountUI/Tooltip/StartInterestTooltip';
import styles from './BalanceListItem.module.scss';

const cn = withStyles(styles);

type BalanceListItemProps = {
  accountType: AccountType;
  balance: Balance;
  selected: boolean;
  onOpenModal: () => void;
};

const BalanceListItem: FC<BalanceListItemProps> = ({
  accountType,
  balance,
  selected,
  // onOpenModal
}) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.AccountBalances' });

  return (
    <div
      style={{
        padding: selected ? '2px' : '1px',
        borderRadius: '20px',
        background: selected
          ? 'linear-gradient(135deg, hsla(0, 0%, 72%, 0.5), hsla(0, 0%, 22%, 0.8), hsla(0, 0%, 72%, 0.5))'
          : 'transparent',
        boxShadow: selected ? undefined : '0 0 34px hsla(0, 0%, 18%, 0.10)',
      }}
    >
      <Card
        className={cn('balanceListItem')}
        style={{
          padding: '16px',
          backgroundColor: selected ? '#f0f0f0' : '#ffffff',
          boxShadow: selected ? undefined : '0 0 34px hsla(0, 0%, 18%, 0.10)',
          border: 'none',
        }}
      >
        <Flag flag={balance.Currency} width="40px" />

        <div>
          {accountType === 'disabled' ? (
            // when the interest account is disabled, hide the functionality for now. it will be shown as a locked feature later
            // <StartInterestTooltip onOpenModal={onOpenModal} customElement={<AccountTypeBadge status={accountType} />} />
            <></>
          ) : (
            <div style={{ paddingBottom: '8px' }}>
              <AccountTypeBadge status={accountType} />
            </div>
          )}

          <div className={cn('currency')}>{balance.Currency}</div>

          <div className={cn('grid')}>
            <div className={cn('gridLabel')}>{t('accountBalance')}</div>
            <div className={cn(balance.AccountBalance < 0 && 'negative')}>{formatAmount(balance.AccountBalance)}</div>

            <div className={cn('gridLabel')}>{t('availableBalance')}</div>
            <div className={cn(balance.AccountBalance < 0 && 'negative')}>{formatAmount(balance.AvailableFunds)}</div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default BalanceListItem;
